<template>
  <span
    :class="containerClass"
    :title="value"
    @dblclick="toggle"
    class="article-number"
  >{{value}}</span>
</template>

<script>
export default {
  name: 'article-number',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    containerClass() {
      return {
        'article-number--expanded': this.isExpanded,
      };
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss">
.article-number {
  display: inline-block;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;

  &--expanded {
    overflow-x: auto;
    overflow-y: none;
    text-overflow: initial;
  }
}
</style>



// WEBPACK FOOTER //
// ArticleNumber.vue?b376a914